/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da01722920723bb6fed4f3ec99e87e60>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconNew = _interopRequireDefault(require("@atlaskit/icon/components/icon-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "Hourglass".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/hourglass
 * Usage guidance:
 * Aging or expiring items
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const HourglassIcon = props => /*#__PURE__*/_react.default.createElement(_iconNew.default, Object.assign({
  name: "HourglassIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" d="M11 12.392c0-.445-.169-.87-.468-1.192l-.136-.13L8 8.99l-2.396 2.08A1.75 1.75 0 0 0 5 12.392V13.5h6zM11 2.5H5v1.108c0 .508.22.99.604 1.323L8 7.008l2.396-2.077.136-.131c.3-.322.468-.747.468-1.192zm1.5 1.108a3.25 3.25 0 0 1-.991 2.337l-.13.12L9.145 8l2.234 1.936.13.119a3.25 3.25 0 0 1 .991 2.337V13.5H14V15H2v-1.5h1.5v-1.108a3.25 3.25 0 0 1 1.121-2.456L6.854 8 4.621 6.064A3.25 3.25 0 0 1 3.5 3.608V2.5H2V1h12v1.5h-1.5z"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
HourglassIcon.displayName = 'HourglassIcon';
var _default = exports.default = HourglassIcon;